// src/admin/pages/AdminDashboard.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import Sidebar from '../../components/Sidebar';

const DashboardContainer = styled.div`
  display: flex;
  min-height: 100vh;
`;

const Content = styled.main`
  flex: 1;
  padding: 2rem;
  background-color: #f5f5f5;
  overflow-y: auto;
`;

const AdminDashboard = () => {
  return (
    <DashboardContainer>
      <Sidebar />
      <Content>
        <Outlet />
      </Content>
    </DashboardContainer>
  );
};

export default AdminDashboard;